import { cn } from '@insta-club/utilities';
import { IconProps } from './icons-props';

function TrashIcon({ className, width = 24, height = 24 }: IconProps) {
    return (
        <svg
            className={cn('text-gray-700', className)}
            width={width}
            height={height}
            viewBox='0 0 24 25'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                d='M21 6.47998C17.67 6.14998 14.32 5.97998 10.98 5.97998C9 5.97998 7.02 6.07998 5.04 6.27998L3 6.47998'
                stroke='#FF3257'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M8.5 5.47L8.72 4.16C8.88 3.21 9 2.5 10.69 2.5H13.31C15 2.5 15.13 3.25 15.28 4.17L15.5 5.47'
                stroke='#FF3257'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M18.8499 9.63989L18.1999 19.7099C18.0899 21.2799 17.9999 22.4999 15.2099 22.4999H8.7899C5.9999 22.4999 5.9099 21.2799 5.7999 19.7099L5.1499 9.63989'
                stroke='#FF3257'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M10.3301 17H13.6601'
                stroke='#FF3257'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path d='M9.5 13H14.5' stroke='#FF3257' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
        </svg>
    );
}

export default TrashIcon;

